import { Message } from 'element-ui';
// import Qs from 'qs';
import './loadingbar.css';

const plugin = {};

plugin.install = (Vue, axios) => {
  if (plugin.installed || !axios) {
    return;
  }
  plugin.installed = true;

  // bind axios to Vue
  Vue.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      },
    },
    $http: {
      get() {
        return axios;
      },
    },
  });

  // global set axios
  axios.defaults.headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  // eslint-disable-next-line
  axios.defaults.transformRequest = [function (data) {
    // 对post传参进行处理，此处未对array、object进行处理，array会使用逗号分隔，object会被处理为[object object];
    let newData = '';
    // eslint-disable-next-line
    for (let k in data) {
      newData += `&${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    }
    if (newData.indexOf('&') === 0) {
      newData = newData.substring(1);
    }
    return newData;
  }];
  // // eslint-disable-next-line
  // axios.defaults.paramsSerializer = function(params) {
  //   return Qs.stringify(params, { arrayFormat: 'brackets' });
  // };
  // axios loading animation
  let loadingAnimation;

  Vue.startLoading = function startLoading() {
    if (!document.getElementById('loadingbar')) {
      const $loadingbar = document.createElement('div');
      $loadingbar.id = 'loadingbar';
      $loadingbar.className = 'waiting';
      $loadingbar.innerHTML = '<dt/><dd/>';
      document.body.appendChild($loadingbar);

      const $loadingbarspinner = document.createElement('div');
      $loadingbarspinner.id = 'loading-bar-spinner';
      $loadingbarspinner.innerHTML = '<div class="spinner-icon"></div>';
      document.body.appendChild($loadingbarspinner);

      let width = 1;
      // eslint-disable-next-line
      loadingAnimation = setInterval(function() {
        if (width >= 90) {
          clearInterval(loadingAnimation);
        }
        // eslint-disable-next-line
        $loadingbar.style.width = `${width++}%`;
      }, 10);
    }
  };
  Vue.endLoading = function endLoading() {
    const $loadingbar = document.getElementById('loadingbar');
    const $spinner = document.getElementById('loading-bar-spinner');
    if ($loadingbar && $spinner) {
      clearInterval(loadingAnimation);
      $loadingbar.className = 'end';
      $loadingbar.style.width = '101%';
      document.body.removeChild($spinner);
      // eslint-disable-next-line
      setTimeout(function() {
        document.body.removeChild($loadingbar);
      }, 600);
    }
  };
  // set axios
  let startTimestamp;
  // let endTimestamp;
  const loadingStack = [];

  axios.interceptors.request.use((config) => {
    startTimestamp = (new Date()).getTime();
    if (loadingStack.length === 0) {
      Vue.startLoading();
    }
    loadingStack.push(startTimestamp);
    return config;
  }, (error) => {
    Promise.reject(error);
  });

  function showMessage(response) {
    const data = response.data;
    const config = response.config;
    if (data && !config.hideMessage) {
      const errno = response.data.errno;
      let msg = data.errmsg;
      let type = 'error';
      if (config.message) {
        msg = config.message[errno];
      }
      if (errno === 0 || errno === '0') {
        type = 'success';
        return;
      }
      if (msg || config.method !== 'get' || type !== 'success') {
        Message({
          message: msg || (type === 'success' ? '操作成功' : '操作失败，请稍候再试'),
          type,
        });
      }
    }
  }
  axios.interceptors.response.use((response) => {
    if (response.data) {
      showMessage(response);
    }
    if (loadingStack.length === 1) {
      Vue.endLoading();
    }
    loadingStack.pop();
    return response;
  }, (error) => {
    Message({
      message: '系统错误',
      type: 'error',
    });
    if (loadingStack.length === 1) {
      Vue.endLoading();
    }
    loadingStack.pop();
    return Promise.reject(error);
  });
};
export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/vue-axios-init/index.js